import { render, staticRenderFns } from "./KepuColumn.vue?vue&type=template&id=132af71a&scoped=true"
import script from "./KepuColumn.vue?vue&type=script&lang=js"
export * from "./KepuColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132af71a",
  null
  
)

export default component.exports